import { ref } from 'vue'

const show = ref(false)
const title = ref('Confirm Action')
const message = ref('')
const color = ref('primary')
const icon = ref('')
const confirmText = ref('Confirm')
const cancelText = ref('Cancel')
const cancelColor = ref('')
const loading = ref(false)
const confirmDisabled = ref(false)
const warnText = ref('')
let pendingResolver = null

export function useConfirmationState() {
  function cancel() {
    close(false)
  }

  function close(result = false) {
    show.value = false
    loading.value = false
    confirmDisabled.value = false

    if (typeof pendingResolver === 'function') {
      const resolve = pendingResolver
      pendingResolver = null
      resolve(Boolean(result))
    }
  }

  function confirm(options = {}) {
    if (typeof pendingResolver === 'function') {
      close(false)
    }

    const {
      cancelButtonColor = '',
      cancelButtonText = 'Cancel',
      confirmButtonText = 'Confirm',
      dialogColor = 'primary',
      dialogIcon = '',
      dialogLoading = false,
      dialogMessage = '',
      dialogTitle = 'Confirm Action',
      dialogWarnText = '',
      disabled = false,
    } = normalizeOptions(options)

    title.value = dialogTitle
    message.value = dialogMessage
    color.value = dialogColor
    icon.value = dialogIcon
    confirmText.value = confirmButtonText
    cancelText.value = cancelButtonText
    cancelColor.value = cancelButtonColor
    loading.value = dialogLoading
    confirmDisabled.value = disabled
    warnText.value = dialogWarnText
    show.value = true

    return new Promise((resolve) => {
      pendingResolver = resolve
    })
  }

  function onCancel() {
    cancel()
  }

  function onConfirm() {
    close(true)
  }

  function setConfirmDisabled(nextValue) {
    confirmDisabled.value = Boolean(nextValue)
  }

  function setLoading(nextValue) {
    loading.value = Boolean(nextValue)
  }

  return {
    cancel,
    cancelColor,
    cancelText,
    close,
    color,
    confirm,
    confirmDisabled,
    confirmText,
    icon,
    loading,
    message,
    onCancel,
    onConfirm,
    setConfirmDisabled,
    setLoading,
    show,
    title,
    warnText,
  }
}

function normalizeOptions(options) {
  if (typeof options === 'string') {
    return {
      dialogMessage: options,
    }
  }

  if (!options || typeof options !== 'object') {
    return {}
  }

  return options
}
